import { useEffect } from "react"
import { useParams } from "react-router-dom"
import { Input, Button, Form, Space } from 'antd'
import { useForm } from "antd/lib/form/Form"
import { axiosHandleEvent, baseAxiosNoInfo } from "../../tool/axios"
import { SelectArea } from "../../component/common/Selects"
import _ from 'lodash'

let formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 12 }
}

let tailLayout = {
    wrapperCol: { offset: 6, span: 12 }
}

export default function MenuEdit() {

    const { id }: { id: string | undefined } = useParams()
    const [form] = useForm()

    useEffect(() => {
        if (id) {
            baseAxiosNoInfo('/mall_center/config/supply/detail', { params: { supply_id: id } }).then((res: any) => {
                if (res) {
                    let codes = { province_code: res.province_code, city_code: res.city_code, area_code: res.area_code }

                    form.setFieldsValue({
                        supply_name: res.supply_name,
                        contact_man: res.contact_man,
                        contact_phone: res.contact_phone,
                        location: res.location,
                        detail_addr: res.detail_addr,
                        codes
                    })
                }
            })
        }
    }, [])

    const onFinish = (values: any) => {

        let url = id ? '/mall_center/config/supply/update' : '/mall_center/config/supply/add'
        let { province_code, city_code, area_code } = values.codes || { province_code: '', city_code: '', area_code: '' }

        axiosHandleEvent.post(url, {
            supply_id: id,
            supply_name: values.supply_name,
            contact_man: values.contact_man,
            contact_phone: values.contact_phone,
            location: values.location,
            province_code,
            city_code,
            area_code,
            detail_addr: values.detail_addr
        })
    }

    return (<div className="common-level2-edit">
        {/* 商城中心 -> 配置管理 -> 供应商管理 -> 新增或编辑 */}
        <h2>{(id ? '编辑' : '新增') + '供应商'}</h2>

        <div className="common-main">
            <Form {...formItemLayout} form={form} name="basic" onFinish={onFinish}>
                <Form.Item
                    label="供应商名称"
                    name="supply_name"
                    rules={[{ required: true, message: '输入供应商名称，限30字内' }]}
                >
                    <Input type="text" maxLength={30} placeholder="输入供应商名称，限30字内" />
                </Form.Item>

                <Form.Item
                    label="联系人"
                    name="contact_man"
                    rules={[{ required: true, message: '输入联系人' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="联系电话"
                    name="contact_phone"
                    rules={[{ required: true, message: '输入联系方式' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="所在地"
                    name="location"
                    rules={[{ required: true, message: '输入所在地' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="省市区"
                    name="codes"
                    rules={[{ required: true, message: '选择省市区' }]}
                >
                    <SelectArea />
                </Form.Item>

                <Form.Item
                    label="具体地址"
                    name="detail_addr"
                    rules={[{ required: true, message: '输入具体地址' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Space>
                        <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" htmlType="submit">提交</Button>
                        <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { window.history.go(-1) }} >返回</Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>
    </div>)
}